import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoanFormType } from 'views/orders/loans/types';

import { OptionalChoiceForm } from '../optional-choice-form';

type Props = {
  control: Control<LoanFormType, object>
  isDataLoading: boolean,
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const DemandFeatureForm: FC<Props> = ({ control, isDataLoading, onSave }) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="demand_feature"
      render={({ field }) => (
        <OptionalChoiceForm
          onBlur={() => { onSave(); }}
          title={t('loanDisclosures:demand-feature')}
          description={t('loanDisclosures:demand-feature-subtitle')}
          value={field.value}
          options={[
            {
              label: t('loanDisclosures:demand-feature-option-1'),
              disabled: isDataLoading,
              value: true
            },
            {
              label: t('loanDisclosures:demand-feature-option-2'),
              disabled: isDataLoading,
              value: false
            }
          ]}
          onChange={(value) => field.onChange(value)}
          onSave={() => { onSave(); }}
        />
      )}
    />
  );
};
